import imageDrop from "../extensions/image_drop.js"
import linkConverter from "../extensions/link_converter"
import { promptImage } from "../../../prompt_file.js"

/**
 * Clean-lane rich text editor.
 *
 * ADDITIVE: nothing renders this until a call site passes variant={:clean}.
 * The four existing flavors (simple, extended, comments, contributions) are
 * untouched, so every current editor keeps the toolbar it has today.
 *
 * `extended` offers nine toolbar groups -- font family, size, colour,
 * background, four inline marks, two list types, alignment, indent, clean,
 * link, attach, image. That is a word processor. This offers two groups:
 * the formatting people actually use, and the three insert actions.
 *
 * Everything dropped is still reachable: Quill keeps its keyboard shortcuts
 * for bold/italic/underline regardless of whether a button is on the toolbar,
 * and pasted rich text retains its formatting.
 */
const clean = {
  extensions: ["link_converter", "image_drop"],

  toolbarOptions() {
    return {
      container: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", { image: "0" }, { custom_attach: "0" }],
      ],
      handlers: {
        custom_attach: (_value) => this.attach(),
        image: (_value) => this.inline(),
      },
    }
  },

  attach() {
    // Matches `extended`: the surrounding form owns the file input, the
    // toolbar button just triggers it.
    const fileInput = this.hiddenInput.form?.querySelector('input[type="file"]')
    if (fileInput) fileInput.click()
  },

  async inline() {
    const file = await promptImage()
    if (!file) return
    const module = this.getModules().imageDropAndPaste
    await module.insertImage(file)
  },
}

export default Object.assign({}, clean, linkConverter, imageDrop)
